// 弃用，不建议使用过滤器
// 请不要改动这个文件，如果需要在Vue.filter上面添加方法，请团队沟通

import parseTime from 'evenlea-utils/dateTime/parseTime';

let setFilter = {};
setFilter.install = function (Vue, options) {
  Vue.filter('yhcFilterMoney', function filterMoney(value, isInt = false) {
    return isInt ? Math.round(value / 100) : value / 100;
  });
  Vue.filter('yhcParseTime', parseTime);
};

export default setFilter;
